export default {
  TAB_SELECT: 'TAB_SELECT',
};
